import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import PropTypes from 'prop-types'; // For type-checking props
import styles from './index.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import SL from '../../assets/images/flags/srilanka.svg';
import UK from '../../assets/images/flags/uk.svg';
import { useTranslation } from 'react-i18next';

const LanguageDropdown = forwardRef(({ options, placeholder, onSelect, value }, ref) => {
  
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(i18n.language === 'si'? 'සිංහල': i18n.language === 'ta'? 'தமிழ்' : 'ENG');
  const dropdownRef = useRef(null);
  const [filteredOptions, setFilteredOptions] = useState(options);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
    setFilteredOptions(options);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option.name);
    onSelect(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useImperativeHandle(ref, () => ({
    clearSelection: () => setSelectedOption(''),
  }));

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <button
        type='button'
        onClick={handleToggle}
        className={
          selectedOption === '' && value === undefined
            ? styles.dropdownButton
            : styles.dropdownSeletedButton
        }
      >
        <img src={selectedOption === 'ENG' ? UK : SL} alt='Flag' className={styles.flagImg} />
        {selectedOption || placeholder || 'Select an Option'}
        {isOpen ? <FontAwesomeIcon icon={faAngleUp} className={styles.flagIcon} /> : <FontAwesomeIcon icon={faAngleDown} className={styles.flagIcon} />}
      </button>
      {isOpen && (
        <div className={styles.dropdownMenuContainer}>
          <ul className={styles.dropdownMenu}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <li key={option.id} onClick={() => handleOptionClick(option)}>
                  <img src={option.name === 'ENG' ? UK : SL} alt='Flag' className={styles.flagListImg} />{option.name}
                </li>
              ))
            ) : (
              <li className={styles.noOptions}>No Options Found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
});

LanguageDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

export default LanguageDropdown;